module.exports = new __parcel__URL__("bear_paw.bdc61759.png").toString();